import { Input } from '@ps/web-shared-components';
import type { Error } from '@ps/web-shared-validators';
import {
  maxLength,
  minLength,
  noWhiteStartOrEnd,
  required,
  validateAllowedCharacters
} from '@ps/web-shared-validators';
import React from 'react';

import {
  TXTWCL_House_Number_cannot_be_longer__ELL,
  TXTWCL_House_number,
  TXTWCL_House_number_cannot_be_0X_00X__ELL,
  TXTWCL_House_number_must_be_providedX,
  TXTWCL_Street_Name,
  TXTWCL_Street_Name_cannot_be_longer_t_ELL,
  TXTWCL_Street_Name_cannot_be_shorter__ELL,
  TXTWCL_Street_name_must_be_providedX,
  TXTWCL_Your_house_number_should_only__ELL
} from './StreetAddressExtended.messages.json';

interface Props {
  disabled?: boolean;
}

const STREET_NAME_ALLOWED_CHARACTERS = /^[\u00C4\u00D6\u00DC\u00DFA-Z0-9',-./´`\s]*$/i;
const BUILDING_NUMBER_ALLOWED_CHARACTERS = /^[\u00C4\u00D6\u00DC\u00DFA-Z0-9,-./\s]*$/i;
const STREET_NAME_VALID_CHARACTERS = /[\u00C4\u00D6\u00DC\u00DFA-Za-z0-9',-./´`]/g;
const BUILDING_NUMBER_VALID_CHARACTERS = /[\u00C4\u00D6\u00DC\u00DFA-Za-z0-9',-./´`]/g;
const ONLY_ZEROS = /^0+$/;

const notAllZeros = (value: string): Error => ({
  valid: !!value && !ONLY_ZEROS.test(value),
  message: TXTWCL_House_number_cannot_be_0X_00X__ELL
});

const StreetAddressExtended: React.FC<Props> = ({ disabled }) => (
  <>
    <Input
      id="streetName"
      label={TXTWCL_Street_Name}
      disabled={disabled}
      validators={[
        required([TXTWCL_Street_name_must_be_providedX, TXTWCL_Your_house_number_should_only__ELL]),
        minLength(4, { ...TXTWCL_Street_Name_cannot_be_shorter__ELL, values: { 0: 4 } }),
        noWhiteStartOrEnd,
        maxLength(150, { ...TXTWCL_Street_Name_cannot_be_longer_t_ELL, values: { 0: 150 } }),
        validateAllowedCharacters(STREET_NAME_ALLOWED_CHARACTERS, STREET_NAME_VALID_CHARACTERS)
      ]}
    />
    <Input
      id="buildingNumber"
      label={TXTWCL_House_number}
      disabled={disabled}
      validators={[
        required(TXTWCL_House_number_must_be_providedX),
        notAllZeros,
        noWhiteStartOrEnd,
        maxLength(20, { ...TXTWCL_House_Number_cannot_be_longer__ELL, values: { 0: 20 } }),
        validateAllowedCharacters(
          BUILDING_NUMBER_ALLOWED_CHARACTERS,
          BUILDING_NUMBER_VALID_CHARACTERS
        )
      ]}
    />
  </>
);

export default StreetAddressExtended;
